<template>
    <component :is="tagMap[size]" class="heading" :class="[size, usage]"><slot /></component>
</template>

<script lang="ts">
export type HeaderSize = "xl" | "m" | "s";
export type HeaderUsage = "nadia" | "system";

interface BaseHeaderProps {
    size?: HeaderSize;
    usage?: HeaderUsage;
}
</script>

<script setup lang="ts">
const { size = "m", usage = "system" } = defineProps<BaseHeaderProps>();

const tagMap: Record<HeaderSize, string> = {
    xl: "h2",
    m: "h4",
    s: "h5",
};
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .heading.xl.nadia {
        @apply display-serif;
    }

    .heading.xl.system {
        @apply display-sans-serif;
    }

    .heading.m.nadia {
        @apply display-small-serif;
    }

    .heading.m.system {
        @apply title-subsection;
    }

    .heading.s.nadia {
        @apply nadia-title-subsection;
    }

    .heading.s.system {
        @apply title-body-bold;
    }
}
</style>
